export function IsDisabledForDrivenMovementsVehicleBodyType(bodyType: string): boolean {
  if (!bodyType) {
    return false;
  }

  return (
    bodyType === 'MOTORCYCLE' ||
    bodyType === 'SCOOTER' ||
    bodyType === 'MOPED' ||
    bodyType === 'L-CATEGORY'
  );
}
